import { ImplementsService } from '@karnott/core-js';
import { API_BASE } from '../../constants';

export default new ImplementsService({
  apiBase: API_BASE,
});
